import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { TrainTypeEnum } from "../../../Orchestrator/Types/Enums/globalDefaultEnum";
import { IFmlmBookNowClickActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/FmlmBookNowClickActionParams";
import { Offer } from "../../../Orchestrator/Types/Types/OffersResponse";
import { TrainType } from "../../../Orchestrator/Types/Types/TrainTypes";
import { convertOffersToTrainsAction } from "../BookItAgain/ConvertOffersToTrainsAction";
import { getLegsSummaryFromTripAction } from "../TrainOffer/GetLegsFromTripAction";
import { passengerTicketSummaryAction } from "../TrainOffer/PassengerTicketSummaryAction";

export class FmlmBookNowClickAction extends BaseAction<void, IFmlmBookNowClickActionParams> {
  override async run() {
    try {
      const { selectedJourney, fmlmViewOffersMap, offersRequest, passengerSpecificationsTypes, trainType, selectedTrainLegs } = this.params!

      const offerResponse = fmlmViewOffersMap.get(selectedJourney.id);
      if (!offerResponse) {
        throw new Error(`No offer response found for journey ID: ${selectedJourney.id}`);
      }

      updateRecoilState("offerAtom", offerResponse.offers);
      updateRecoilState("tripOfferAtom", offerResponse.trips);

      let selectedOfferId = null
      let selectedTicketType = "";
      if (selectedJourney.tripOffer?.standardOffer) {
        selectedOfferId = selectedJourney.tripOffer.standardOffer.offerId
        selectedTicketType = "standardValue";
      } else if (selectedJourney.tripOffer?.standardProOffer) {
        selectedOfferId = selectedJourney.tripOffer.standardProOffer.offerId
        selectedTicketType = "standardPro";
      } else if (selectedJourney.tripOffer?.premiumOffer) {
        selectedOfferId = selectedJourney.tripOffer.premiumOffer.offerId
        selectedTicketType = "premium";
      }
      updateRecoilState<string | null>("selectedOfferIdAtom", selectedOfferId);
      updateRecoilState<string>("ticketTypeStateAtom", selectedTicketType);
      let selectedShuttleOfferId = selectedJourney.tripOffer?.shuttleOffer?.offerId || null;
      updateRecoilState("selectedShuttleOfferIdAtom", selectedShuttleOfferId);

      if (selectedJourney.tripOffer?.trip) {
        getLegsSummaryFromTripAction.setParams({
          trip: selectedJourney.tripOffer?.trip,
          tripDirection: trainType === TrainTypeEnum.outbound ? TrainTypeEnum.outbound : TrainTypeEnum.inbound,
          trainLegsValue: selectedTrainLegs
        })
        await getLegsSummaryFromTripAction.execute();
      }

      convertOffersToTrainsAction.setParams({
        offersData: selectedJourney.tripOffer ? [selectedJourney.tripOffer] : [],
        type: trainType
      })
      await convertOffersToTrainsAction.execute();

      let selectedTrain: TrainType | null = convertOffersToTrainsAction.result?.[0] || null;
      if (selectedTicketType && selectedTrain) {
        selectedTrain['selectedPriceClass'] = selectedTicketType as TrainType["selectedPriceClass"];

        passengerTicketSummaryAction.setParams({
          train: selectedTrain,
          priceClass: selectedTicketType,
          offers: offerResponse.offers as unknown as Offer[],
          type: trainType,
          offersRequest: offersRequest,
          passengerSpecificationsTypes: passengerSpecificationsTypes
        })
        await passengerTicketSummaryAction.execute();
      }

      if (trainType === TrainTypeEnum.outbound) {
        updateRecoilState<TrainType | null>("selectedOutboundTrainAtom", selectedTrain || null);
      } else if (trainType === TrainTypeEnum.inbound) {
        updateRecoilState<TrainType | null>("selectedInboundTrainAtom", selectedTrain || null);
      }
      updateRecoilState<TrainType[]>("trainAtom", convertOffersToTrainsAction.result || []);
    } catch (error) {
      console.error("Error in FmlmBookNowClickAction:", error);
    }
  }
}

export const fmlmBookNowClickAction = new FmlmBookNowClickAction()
